import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { AlertTriangle, Check, ArrowRight, MessageCircle } from 'lucide-react';

const CheckoutCanceled: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 text-center">
          {/* Warning Icon */}
          <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6">
            <AlertTriangle className="h-10 w-10 text-yellow-500" />
          </div>

          {/* Message */}
          <h1 className="text-3xl font-bold text-foreground mb-3">
            Checkout Canceled
          </h1>
          <p className="text-lg text-muted-foreground mb-8">
            You cancelled the checkout process. No charges have been made.
          </p>

          {/* Why Subscribe */}
          <div className="bg-primary/5 border border-primary/20 rounded-lg p-6 mb-8 text-left">
            <h2 className="font-semibold text-foreground mb-3">Why Subscribe?</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start">
                <Check className="h-5 w-5 text-primary mr-2 flex-shrink-0 mt-0.5" />
                <span>14-day free trial with full access</span>
              </li>
              <li className="flex items-start">
                <Check className="h-5 w-5 text-primary mr-2 flex-shrink-0 mt-0.5" />
                <span>AI-powered translations in 20+ languages</span>
              </li>
              <li className="flex items-start">
                <Check className="h-5 w-5 text-primary mr-2 flex-shrink-0 mt-0.5" />
                <span>Cancel anytime, no questions asked</span>
              </li>
              <li className="flex items-start">
                <Check className="h-5 w-5 text-primary mr-2 flex-shrink-0 mt-0.5" />
                <span>24/7 priority support</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Button asChild className="w-full">
              <Link to="/pricing">
                Try Again
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" className="w-full">
              <Link to="/dashboard">
                Back to Dashboard
              </Link>
            </Button>
          </div>

          {/* Support */}
          <p className="text-sm text-muted-foreground mt-6 flex items-center justify-center">
            <MessageCircle className="h-4 w-4 mr-1" />
            Have questions?{' '}
            <a href="#" className="text-primary hover:underline ml-1">
              Chat with us
            </a>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutCanceled;
